import { apiGenerator } from '../../../framework/apis/apiGenerator';
import { env } from '../../../framework/utils/EnvUtils';
import { AssignMessageGetResult } from '../../models/gen/assignMessageGetResult';
import { IdParam } from '../../models/gen/idParam';
import { useGenericQuery } from '../../utils/ReactQueryUtils';
import { queryOptions } from './base';

export const DAILY_MATTER_CONTEXT_NAMES = {
  GET_DAILY_MATTER_ASSIGN_MESSAGE: 'getAssignMessage',
} as const;

const apis = apiGenerator();

/**
 * GET `/daily-matter/assign-message/{id}`
 *
 * @param param -
 * @returns
 */
export const useGetDailyMatterAssignMessage = (param: IdParam) =>
  useGenericQuery(
    [
      DAILY_MATTER_CONTEXT_NAMES.GET_DAILY_MATTER_ASSIGN_MESSAGE,
      param as Record<string, unknown>,
    ],
    async (_param) =>
      apis.get<void, AssignMessageGetResult>(
        `${env.BASE_API_ENDPOINT}/daily-matter/assign-message/${param.id}`,
        { ...queryOptions }
      ),
    { enabled: false }
  );
